import React from 'react';
import { Link } from "react-router-dom";

export const CheckoutShipping = () => {
  return (
    <div className="lg:p-8 p-4 border-r-[1px] 2xl:h-screen">
      <div className="w-full lg:w-5/6 2xl:w-9/12 lg:ml-auto">
        
          <div>
            <h1><Link to="/"><img src="images/logo.svg" alt="Sightkart" className="w-52" /></Link></h1>
            <ul className="checkout_list flex text-sm mt-4 mb-6 text-gray-500">
              <li><Link to="/checkout"><span className="text-cyan-500">Information</span></Link></li>
              <li><span className="font-medium">Shipping</span></li>
              <li>Payment</li>
            </ul>
          </div>

          <div className="border rounded p-4">
            <div className="flex text-sm mb-2 md:gap-5 gap-3 text-gray-500">
              <div>Contact</div>
              <div>surinder.techies@gmail.com</div>
              <div className="ml-auto text-cyan-500"><Link to="/checkout">Change</Link></div>
            </div>
            <hr />
            <div className="flex text-sm mt-2 md:gap-5 gap-3 text-gray-500">
              <div>Ship to</div>
              <div>Sarabha Nagar, SCF 12 c, 141001 Ludhiana</div>
              <div className="ml-auto text-cyan-500"><Link to="/checkout">Change</Link></div>
            </div>
          </div>
          <h3 className="text-xl text-gray-700 mt-8">Shipping method</h3>
          <div className="flex border rounded p-4 justify-between mt-2">
            <div className="content-center flex gap-1">
              <label style={{display: '-webkit-box'}}><input type="radio" name="" checked="checked" /> <span className="text-sm text-gray-500 ml-1">Standard</span></label>
            </div>
            <div className="text-sm text-gray-500">$20.00</div>
          </div>
          <div className="flex-wrap md:flex mt-10 justify-between items-center">
            <div className="text-cyan-500">
              <Link to="/checkout"><i className="fa fa-angle-left mr-3"></i> <span className="md:text-sm lg:text-base">Return to information</span></Link>
            </div>
            <div>
              <Link to="/payment" className="bg-cyan-500 uppercase text-white font-light rounded py-3 px-3 lg:px-8 mt-2 ml-auto block md:text-sm lg:text-base">Continue to Payment</Link>
            </div>
          </div>

          <div className="content-end hidden md:inline-block">
            <hr className="mt-6 mb-4" />
            <div className="flex gap-4 text-cyan-500 text-sm font-light">
              <a href="#" target="_blank" rel="noopener noreferrer">Refund policy</a>
              <a href="#" target="_blank" rel="noopener noreferrer">Shipping policy</a>
              <a href="#" target="_blank" rel="noopener noreferrer">Privacy policy</a>
              <a href="#" target="_blank" rel="noopener noreferrer">Terms of service</a>
            </div>
          </div>

      </div>
    </div>
  )
}